import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Home from "./components/pages";
import TrainingPage from "./components/pages/TrainingPage";
import TechPage from "./components/pages/TechPage";
import TalksPage from "./components/pages/TalksPage";
import FakeNewsPage from "./components/pages/FakeNewsPage";
import TeamsPage from "./components/pages/TeamsPage";
import ProjectsPage from "./components/pages/ProjectsPage";
import MeditationPage from "./components/pages/MeditationPage";
import RetreatsPage from "./components/pages/RetreatsPage";
import { trackPageview } from './plausible';

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageview();
  }, [location.pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <RouteChangeTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/training" element={<TrainingPage />} />
        <Route path="/tech" element={<TechPage />} />
        <Route path="/talks" element={<TalksPage />} />
        <Route path="/fakenews" element={<FakeNewsPage />} />
        <Route path="/teams" element={<TeamsPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/meditation" element={<MeditationPage />} />
        <Route path="/retreats" element={<RetreatsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
